/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerlunchhint3Inputs */

const en_placeflyerlunchhint3 = /** @type {(inputs: Placeflyerlunchhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the window and the board – with the dishes from your lunch menu.`)
};

const de_placeflyerlunchhint3 = /** @type {(inputs: Placeflyerlunchhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fürs Schaufenster und die Tafel – mit den Gerichten aus deinem Mittagsmenü.`)
};

/**
* | output |
* | --- |
* | "For the window and the board – with the dishes from your lunch menu." |
*
* @param {Placeflyerlunchhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerlunchhint3 = /** @type {((inputs?: Placeflyerlunchhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerlunchhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerlunchhint3(inputs)
	return de_placeflyerlunchhint3(inputs)
});
export { placeflyerlunchhint3 as "placeFlyerLunchHint" }